import * as types from './meeting-tasks.types';

export const meetingTasksPageSelectors: types.IMeetingTasksPageSelectors = {
  selectMeetingTasks: (state) => state.page.meetingTasks.meetingTasks,
};
